export default "<ion-app>\n\t<!-- (activate)='onActivate($event)' -->\n\t<ion-router-outlet></ion-router-outlet>\n</ion-app>\n  ";